import { useEffect, useRef } from 'react';
import API from '../utils/api';

const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID;

export default function SocialLogin({ onSuccess, onError }) {
  const googleRef = useRef(null);

  useEffect(() => {
    if (!GOOGLE_CLIENT_ID) return;

    const scriptId = 'gsi-client';
    if (!document.getElementById(scriptId)) {
      const s = document.createElement('script');
      s.id  = scriptId;
      s.src = 'https://accounts.google.com/gsi/client';
      s.async = true;
      s.onload = initGoogle;
      document.head.appendChild(s);
    } else if (window.google?.accounts) {
      initGoogle();
    }

    function initGoogle() {
      window.google.accounts.id.initialize({
        client_id: GOOGLE_CLIENT_ID,
        callback: handleGoogleCredential,
        auto_select: false,
      });
      if (googleRef.current) {
        window.google.accounts.id.renderButton(googleRef.current, {
          theme: 'outline',
          size: 'large',
          text: 'continue_with',
          shape: 'rectangular',
          width: googleRef.current.offsetWidth || 320,
        });
      }
    }
  }, []);

  async function handleGoogleCredential(response) {
    try {
      const { data } = await API.post('/auth/google/token', { credential: response.credential });
      onSuccess?.(data);
    } catch (err) {
      onError?.(err.response?.data?.error || 'Google sign-in failed');
    }
  }

  if (!GOOGLE_CLIENT_ID) return null;

  return (
    <div style={{ marginTop: 8 }}>
      <div style={{ display:'flex', alignItems:'center', gap:12, margin:'20px 0' }}>
        <div style={{ flex:1, height:1, background:'var(--border)' }} />
        <span style={{ fontSize:12, color:'var(--text-soft)', whiteSpace:'nowrap' }}>or continue with</span>
        <div style={{ flex:1, height:1, background:'var(--border)' }} />
      </div>
      <div ref={googleRef} style={{ width:'100%', minHeight:44 }} />
    </div>
  );
}
